import React, {
    useRef,
    useEffect,
    useState,
    useReducer,
} from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Form, FormElement } from "@progress/kendo-react-form";
import "./dialogMultiSignature.css";
// import P5ContainerCoordinates from "./P5ContainerCoordinates";
import { useMediaQuery } from "@material-ui/core";
import { PDFDocument } from "pdf-lib";
import { pdfjs } from "react-pdf";
import P5ContainerCoordinates from "./p5ContainerOnePage";
import InstructionsPure from "../instructionsPure/instructionsPure";

const CustomTitleBar = ({ signatureType }) => {
    const { t } = useTranslation();
    return (
        <div className="custom-title">
            <span>
                {t("dialogAcceptSignature.titleAcceptSignRequest", {
                    signatureType: signatureType,
                })}
            </span>
        </div>
    );
};

const DialogOnePage = (props) => {
    const {
        tempImage,
        dataItem,
        nextPage,
        previousPage,
        tempImageWidth,
        tempImageHeight,
        firstPage,
        lastPage,
        close,
        insertSignaturesBySigner,
        showLoadingRequesting,
        toggleLoadingRequesting,
    } = props;
    // const { insertSignaturesBySigner } = props
    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    const [numPages, setNumPages] = useState(props.numPages);
    const [pageNumber, setPageNumber] = useState(props.pageNumber);
    const { t } = useTranslation();
    const [imgPdf, setImgPdf] = useState("");
    const [signatureImage, setSignatureImg] = useState("")
    const [visibleAccept, setVisibleAccept] = useState(false);
    const [divGreyTextSize, setdivGreyTextSize] = useState(700);
    const greyTextRef = useRef(null);

    const saveImage = (nameSigner) => {
        let destinationCanvas = document.createElement("canvas");
        destinationCanvas.height = 300;
        destinationCanvas.width = 600;
        const x = destinationCanvas.width
        let destinationContext = destinationCanvas.getContext("2d");
        destinationContext.font = "bold 25px Arial";
        destinationContext.textAlign = "center";
        destinationContext.fillText(nameSigner, x / 2, 255);

        destinationContext.rect(0,
            0,
            destinationCanvas.width,
            destinationCanvas.height);

        destinationContext.strokeRect(0, 0, destinationCanvas.width, destinationCanvas.height)

        destinationContext.globalCompositeOperation = "destination-over";

        let image = destinationCanvas.toDataURL("image/png");
        return {
            newImg: image,
            imageWidth: destinationCanvas.width,
            imageHeight: destinationCanvas.height,
        };
    };
    useEffect(() => {
        saveImage(dataItem.nameSigner)
        const { newImg } = saveImage(dataItem.nameSigner)
        setSignatureImg(newImg)
        setImgPdf(tempImage)
        setPageNumber(props.pageNumber)
    }, [])

    useEffect(() => {
        setImgPdf(tempImage)
    }, [tempImage])

    let greyText = "dialogAcceptSignature.noticeCreateSignAutografaCustom";
    let instructions = [t(greyText)]
    if(greyText ===
        "dialogAcceptSignature.noticeCreateSignAutografa") instructions.push(t("dialogAcceptSignature.noticeCreateSignAutografa2"))
    const saveCoordinates = () => {
        props.setSigners(
            props.signers.map((item) =>
                props.dataItem.email === item.email
                    ? {
                        ...item,
                    }
                    : item
            )
        );
    };

    const saveAndReload = async (params) => {
        toggleLoadingRequesting(true);
        let temp = {
            ...params,
            page: props.pageNumber,
        };
        let { signatures } = props;
        let fileSignImage = null;
        await fetch(signatureImage)
            .then((res) => res.blob())
            .then((blob) => {
                const file = new File([blob], "signature.png");
                fileSignImage = file;
            });
        let signs = signatures;
        signs.push({
            x: temp.x,
            y: temp.y,
            width: temp.width,
            height: temp.height,
            page: props.pageNumber,
            isMobile: true,
            fileSignImage: fileSignImage,
            imgSignature: signatureImage,
            email: props.dataItem.email,
        });
        const sign = {
            x: temp.x,
            y: temp.y,
            width: temp.width,
            height: temp.height,
            page: props.pageNumber,
            isMobile: true,
            fileSignImage: fileSignImage,
            imgSignature: signatureImage,
            email: props.dataItem.email,
        };
        props.setSignatures(signs);
        insertSignaturesBySigner(sign);
    };

    const deleteSign = (indexInTheirCoordinates, indexAllSigns) => {
        toggleLoadingRequesting(true);
        props.dataItem.numSign--;
        props.dataItem.coordinates.data.splice(indexInTheirCoordinates, 1);
        saveCoordinates();
        props.deleteSignaturesByIndex(indexAllSigns);
    };
    return (
        <>
            <Dialog
                title={
                    <CustomTitleBar
                        // style={{ maxWidth: `${fullWidth}px !important` }}
                        signatureType={t("documentDisplay.locateSign")}
                    />
                }
                className="dialog-signature"
                onClose={() => close()}

            >
                <div className="dialogOnePage-intructions">
                    <InstructionsPure instructions={instructions} />
                </div>
                <div>
                    <Form
                        style={{ margin: "0px" }}
                        onSubmit={() => { }}
                        allowSubmit={true}
                        className="formCustomSignature"
                        valid={true}
                        touched={true}
                        visited={true}
                        render={() => {
                            return (
                                <FormElement
                                    style={{
                                        maxWidth: "450px !important",
                                        width: "100%",
                                        margin: "auto",
                                    }}
                                >
                                    <div>
                                        <div
                                            style={{
                                                maxWidth: tempImageWidth + 16,
                                                maxHeight: tempImageHeight + 16,
                                            }}
                                        >
                                            <div
                                                className={`button-dialog-accept button-dialog-accept-size icons-bars`}
                                            >
                                                <span
                                                    class="k-icon k-i-arrow-double-60-left icon-bar dialog-input-arrow-padding"
                                                    onClick={() => {
                                                        firstPage()
                                                    }}
                                                ></span>
                                                <span
                                                    class="k-icon k-i-arrow-60-left icon-bar dialog-input-arrow-padding"
                                                    onClick={() => previousPage()}
                                                ></span>
                                                <div
                                                    className="pagec"
                                                    style={{
                                                        color: "#427FBA",
                                                        textAlign: "center",
                                                        fontWeight: "bold",
                                                        marginTop: "auto",
                                                        marginBottom: "auto",
                                                        padding: "0px 5px",
                                                    }}
                                                >
                                                    {t("documentDisplay.page")}
                                                    <input
                                                        style={{
                                                            width: "32px",
                                                            marginLeft: "4px",
                                                            marginRight: "3px",
                                                        }}
                                                        type="number"
                                                        value={pageNumber}
                                                        onChange={e => {
                                                            if (Number(e.target.value) >= numPages) {
                                                                setPageNumber(Number(numPages))
                                                            } else if (Number(e.target.value) <= 1) {
                                                                setPageNumber(1)
                                                                // props.setPageNumber(1)
                                                            } else {
                                                                setPageNumber(Number(e.target.value))
                                                            }
                                                        }}
                                                        onKeyDown={e => {
                                                            if (e.key === "Enter") {
                                                                if (pageNumber === "" || pageNumber === 0) {
                                                                    return
                                                                }
                                                                // setPageNumber(props.pageNumber)
                                                                props.setPageNumber(pageNumber)
                                                            }
                                                            else if (e.key === "Backspace") {
                                                                setPageNumber("")
                                                            }
                                                        }}
                                                    />
                                                    {t("documentDisplay.of")} {numPages || "--"}
                                                </div>
                                                <span
                                                    class="k-icon k-i-arrow-60-right icon-bar dialog-input-arrow-padding"
                                                    onClick={() => nextPage()}
                                                ></span>
                                                <span
                                                    class="k-icon k-i-arrow-double-60-right icon-bar dialog-input-arrow-padding"
                                                    onClick={() => {
                                                        lastPage()
                                                    }}
                                                ></span>
                                            </div>
                                            <div>
                                                {imgPdf && !showLoadingRequesting && (
                                                    <P5ContainerCoordinates
                                                        tFunction={t}
                                                        base64Img={imgPdf}
                                                        imgSignature={signatureImage}
                                                        widthImg={tempImageWidth}
                                                        heightImg={tempImageHeight}
                                                        signatures={props.signatures}
                                                        currentPage={props.pageNumber}
                                                        email={props.dataItem.email}
                                                        back={() => close()}
                                                        saveCoordinates={(params) => {
                                                            props.dataItem.numSign++;
                                                            saveCoordinates(params);
                                                        }}
                                                        deleteSign={(indexInTheirCoordinates, indexAllSigns) => deleteSign(indexInTheirCoordinates, indexAllSigns)}
                                                        saveAndReload={(params) => saveAndReload(params)}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </FormElement>
                            );
                        }}
                    />
                </div>
            </Dialog>
        </>
    );
};

export { DialogOnePage as default };